import axios from 'axios'
import { Message, Loading } from 'element-ui'
import app from '../main'
// import {StorageKeys} from './constans'

let loadingInstance = null //这里是loading
//使用create方法创建axios实例
const instance = axios.create({
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})

// 添加请求拦截器
instance.interceptors.request.use(config => {
  loadingInstance = Loading.service({
    lock: true,
    text: 'loading...'
  })
  return config
})
// 添加响应拦截器
instance.interceptors.response.use(response => {
  loadingInstance.close()
  const { status, data } = response
  if (status === 200) {
    switch (data.code) {
      case 0:
      case 200:
        return Promise.resolve(data)
      case 401:
        app.$router.replace('/login').catch(() => {})
      default: 
      app.$message.error(`请求失败：${data.msg}`)
      return Promise.reject(data)
    }
  } else {
    app.$message.error(`请求失败：${status}`)
  }
}, error => {
  console.log('TCL: error', error)
  const msg = error.Message !== undefined ? error.Message : ''
  Message({
    message: '网络错误' + msg,
    type: 'error',
    duration: 3 * 1000
  })
  loadingInstance.close()
  return Promise.reject(error)
})

// function service (url, method, params, options) {
//   return instance({
//     url,
//     method,
//     params,
//     ...options
//   })
// }

export default instance